import { Component, ViewChild, OnInit, ChangeDetectorRef, Input, ElementRef, EventEmitter, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';

import { map, filter } from 'rxjs/operators';
import { Observable } from 'rxjs';

// Interfaces
import { Brand, Menu, MenuBottom, MenuMobile, PageTitle } from '../../../../../utils/models/layout.interface';

// Constants
import { BannerInterface } from '../../../../../utils/models/common.interface';
import { NavigationService } from '../../../service/navigation.service';
import { heightSidenavMenu } from '../../../../shared/functions/utilities.service';
import { ErrorSummaryService } from '../../error-summary/services/error-summary.service';
import { ShownRightService } from '../../../service/shown-right.service';

@Component({
  selector: 'navigation-induxtry',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('drawer') private readonly drawer: MatSidenav;
  @ViewChild('ganttSide') private readonly ganttSide: MatSidenav;

  // Observable
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));
  title$: Observable<string>;
  title: string
  @Input() menus: Menu[];
  @Input() user: Menu;
  @Input() brand: Brand;
  @Input() menuBottom: MenuBottom;
  @Input() disabledTopNav = true;
  @Input() pageTitles: PageTitle[]
  sidenavPositionControl = 'start';
  @Input() mobileSideNavPositionControl;
  @Input() menuMobile: MenuMobile;
  @Input() hasEmitterLogout = false;

  @Output() emitterLogout: EventEmitter<boolean> = new EventEmitter<boolean>();
  myCollapsedUserPanel;
  myCollapse;

  showSideNav = true;
  scroll = false;
  showLabel = false;

  banner: BannerInterface[] = [];

  activeErrorSummary = this.errorSummaryService.handleGetActiveErrorSummary();

  shownRightElement = null;
  keyCloseBanner = '';

  resizeEventListener: () => void;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly changeDetector: ChangeDetectorRef,
    readonly router: Router,
    private readonly el: ElementRef,
    private readonly nav: NavigationService,
    private readonly errorSummaryService: ErrorSummaryService,
    private readonly shownRightService: ShownRightService
  ) {
      router.events.pipe(filter(e => e instanceof NavigationEnd))
        .subscribe((e: NavigationEnd) => this.title = e.url);
  }

  ngOnInit() {
    this.isHandset$.subscribe((res)=>{
      if(res){
        this.sidenavPositionControl = this.mobileSideNavPositionControl
      } else{
        this.sidenavPositionControl = 'start'
      }
    })

    this.nav.banner.subscribe((res) => {
      if (res) {
        const indexBanner = this.banner?.findIndex(item => item.key === res.key);
        if (indexBanner !== -1) {
          this.banner[indexBanner] = res;
        } else {
          this.banner?.push(res)
        }
        setTimeout(() => {
          this.updateContainerHeight();
        }, 300);
      }
    })

    this.errorSummaryService.activeErrorSummary.subscribe((active: boolean) => {
      this.activeErrorSummary = active;
    });

    this.nav.closeBanner.subscribe((bannerClosed: BannerInterface) => {
      this.keyCloseBanner = bannerClosed.key;
    });

    this.shownRightElement = this.shownRightService.getInitialShownRight;
    this.insertShownRightInHTML();
    this.shownRightService.htmlShownRight.subscribe(res => {
      this.shownRightElement = res;
      this.insertShownRightInHTML();
    });
    this.updateContainerHeight();
    this.resizeEventListener = () => {
      this.updateContainerHeight();
    };
    window.addEventListener("resize", this.resizeEventListener);
  }

  updateContainerHeight(): void {
    const list_banners = document.getElementById('js_list_banners'),
          container_system = document.getElementById('js_container_system');
    if (list_banners && container_system) {
      const valueHeight = `calc(100vh - ${list_banners.clientHeight}px)`
      container_system.style.height = valueHeight;

      const containerErrorSummary = document.getElementById('js_container_error_summary')
      if (containerErrorSummary) {
        containerErrorSummary.style.height = valueHeight;
      }
    }
  }

  insertShownRightInHTML() {
    const element = this.el.nativeElement.querySelector('#shown-right');
    if (element) {
      element.innerHTML = '';
      if (this.shownRightElement) {
        element.appendChild(this.shownRightElement);
      }
    }
  }

  ngAfterViewInit(): void {
    heightSidenavMenu();
    setInterval(() => {
      heightSidenavMenu();
    }, 10000);
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  handleClose(event: boolean): void {
    this.isHandset$.subscribe((value) => {
      if (value && event) {
        this.drawer.close();
      }
    });
  }

  closeGanttSide() {
    this.ganttSide.close();
  }

  receiveCollapse(collapse) {
    this.myCollapse = collapse;
    this.isHandset$.subscribe((value) => {
      if (value) {
        document.getElementById('sidenav').style.width = '254px';
        document.getElementById('sidenav').style.right = '0px';
        document.getElementById('sidenav').style.left = '';
        this.sidenavPositionControl = 'end';
      } else {
        this.sidenavPositionControl = 'start';
        if (this.myCollapse) {
          document.getElementById('sidenav').style.width = '198px';
          document.getElementById('sidenav').style.left = '0px';
        } else {
          document.getElementById('sidenav').style.width = '80px';
          document.getElementById('sidenav').style.left = '0px';
        }
      }
    });
  }

  receiveCollapsedUserPanel(collapsedUseMenu) {
    if (!collapsedUseMenu) {
      this.myCollapsedUserPanel = collapsedUseMenu;
    } else {
      this.myCollapsedUserPanel = !this.myCollapsedUserPanel;
    }
  }

  scrollToTop() {
    const contentElement = this.el.nativeElement.querySelector('.content');
    if (contentElement) {
      contentElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      this.showLabel = false
    }
  }

  onScrollTeste(event) {
    const scroll = event?.target?.scrollTop;
    this.scroll = (scroll === 0 ? false : true);
  }

  expandButton(isHovered){
    if (isHovered) {
      this.showLabel = true;
    } else {
      this.showLabel = false;
    }
  }

  closeBanner(event){
    const newArray = this.banner.filter(item => item !== event);
    this.banner = newArray;
    this.keyCloseBanner = '';
    this.updateContainerHeight();
  }

  eventButton(event){
    const value = (event[1] || event);
    this.nav.emitClickButtonBanner(value);
    if (value === 'correct') {
      this.receiveCollapse(false);
      this.receiveCollapsedUserPanel(true);
      this.updateContainerHeight();
    }
  }

  handleClickLogout() {
    this.emitterLogout.emit(true);
  }

  ngOnDestroy(): void {
    window.removeEventListener("resize", this.resizeEventListener);
  }
}
